// src/components/Maintenance.tsx
export default function Maintenance() {
  return (
    <div className="flex flex-col items-center justify-start min-h-screen text-center pt-28 px-6">
      {/* Icon / Emoji */}
      <div className="text-6xl mb-6">🛠️</div>

      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-[#111827] mb-3">
        Under Maintenance
      </h1>

      {/* Subtitle */}
      <p className="text-lg text-[#4B5563] mb-2 max-w-md">
        We’re currently experiencing technical difficulties.
      </p>

      <p className="text-[#6B7280] mb-8 max-w-md">
        Please try again in a few minutes.
      </p>

      {/* Optional accent line / badge */}
      <div className="h-1.5 w-20 bg-[#F97316] rounded-full"></div>
    </div>
  );
}